<!-- 
화면명 : ScmHome.vue
작성일 : 2025-07-01
설명   : 메인 홈화면
-->
<template>
  <div class="mt-2" style="max-width: 1200px">
    <div class="flex text-black font-bold text-lg items-center justify-start mx-2">
      <img src="@/assets/img/breadcrumbs.svg" class="w-4 h-4 mx-2" />
      홈
    </div>
    
    <div class="px-2 mx-auto w-full top-wrapper">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
          <div class="w-full lg:w-3/12 xl:w-3/12 px-2">
            <card-stats
              statSubtitle="자재/외주 발주 건수"
              statIconName="far fa-chart-bar"
              statIconColor="bg-red-500"
              :pCnt="arrSearchData_1?.[0]?.BJ_CNT_J"
              :pTotal="arrSearchData_1?.[0]?.BJ_CNT_O"
            />
          </div>
          <div class="w-full lg:w-3/12 xl:w-3/12 px-2">
            <card-stats
              statSubtitle="출고 자재/외주 건수"
              statIconName="fas fa-chart-pie"
              statIconColor="bg-orange-500"
              :pCnt="arrSearchData_1?.[0]?.SP_CNT_J"
              :pTotal="arrSearchData_1?.[0]?.SP_CNT_O"
            />
          </div>
          <div class="w-full lg:w-3/12 xl:w-3/12 px-2">
            <card-stats
              statSubtitle="미납 자재/외주 건수"
              statIconName="fas fa-chart-line"
              statIconColor="bg-pink-500"
              :pCnt="arrSearchData_1?.[0]?.UN_CNT_J"
              :pTotal="arrSearchData_1?.[0]?.UN_CNT_O"
            />
          </div>
          <div class="w-full lg:w-3/12 xl:w-3/12 px-2">
            <card-stats
              statSubtitle="NCR 발행 건수"
              statIconName="fas fa-chart-simple"
              statIconColor="bg-green-500"
              :pCnt="arrSearchData_1?.[0]?.NCR_CNT"
              :pTotal="null"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end mr-4 mt-2">
      <label class="ml-3 text-black font-bold text-xs px-4">
        총 받은 알림: {{ countUnRead }} / {{ arrSearchData_2.length }}
      </label>
    </div>

    <div class="flex flex-col h-full">
      <!-- 그리드 -->
      <div class="flex flex-1 px-4 mt-2">
        <UCGrid
          :data="arrSearchData_2"
          :isRowNumber="true"
          :columns="columns"
          :selectable="true"
          :pagination="true"
          :paginationSize="50"
          autoHeight
          :excludeSelectors="['.top-wrapper']"
          :heightOffset="60"
          @row-selected="handleSelection"
        />
      </div>

      <div class="flex gap-3 mt-2 ml-3 mb-2 flex">
        <UCButton
          label="선택삭제"
          width="120px"
          icon="delete"
          @click="btnDeleteClick"
        />

        <UCButton
          label="전체 읽음 처리"
          width="150px"
          icon="allread"
          @click="btnReadClick"
        />
      </div>
    </div>

    <!-- 그리드 클릭시 팝업 화면 -->
    <PopupMagam
      v-model="showDialog"
      :title="`${popupData?.[0]?.TITLE}`"
      :sender="popupData?.[0]?.FR_USERNAME"
      :date="`${popupData?.[0]?.FR_DATE} [${popupData?.[0]?.FR_TIME}]`"
      :content="popupData?.[0]?.CONTENTS"
      @emit-close="popupEmitClose"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import { useUserStore } from "@/store/userStore";

import UCGrid from "@/components/UserControl/UCGrid.vue";
import UCButton from "@/components/UserControl/UCButton.vue";

import CardStats from "@/components/ScmHome/CardStats.vue";
import PopupMagam from "@/components/ScmHome/PopupMagam.vue";

import { apiExecuteDataSet } from "@/api/SCM/common";

import IconEmail_Y from "@/assets/img/email-open-outline.svg";
import IconEmail_N from "@/assets/img/email-variant.svg";

const userStore = useUserStore();

const arrSearchData_1 = ref([]);
const arrSearchData_2 = ref([]);
let countUnRead = ref(0); // 미 읽은 카운트

onMounted(async () => {
  //console.log("onMounted ScmHome", userStore.userId);

  search();
});

async function search() {
  countUnRead.value = 0;

  const searchParams = {
    
    ID: "WERP\\T_ALARM\\R005",
    Parameter: {
      "@USID": userStore.userVendCd,
    },
  };

  const searchParams2 = {
    
    ID: "WERP\\T_ALARM\\R001",
    Parameter: {
      "@R_OR_S": "R",
      "@USID": userStore.userId,
      "@PAGENO": 1,
      "@PAGEINROW": 10000,
      "@CURPAGE": "",
      "@MAXPAGE": "",
      "@TOTALCOUNT": "",
      "@NOTREAD": "",
    },
  };

  const res = await Promise.all([
    apiExecuteDataSet(searchParams),
    apiExecuteDataSet(searchParams2),
  ]);
  // console.log("res", res);

  arrSearchData_1.value = res[0]._Result[0];
  arrSearchData_2.value = res[1]._Result[0];
  // console.log("arrSearchData_1", arrSearchData_1.value);
  // console.log("arrSearchData_2", arrSearchData_2.value);

  for (let i = 0; i < arrSearchData_2.value.length; i++) {
    if (arrSearchData_2.value[i].READ_GBN !== "Y") {
      countUnRead.value++;
    }
  }
}

const selectedRows = ref([]);
const columns = [
  {
    title: "",
    formatter: "rowSelection",
    titleFormatter: "rowSelection",
    hozAlign: "center",
    headerSort: false,
    width: 50,
  },
  {
    title: "SEQ",
    field: "SEQ",
    widthGrow: 1,
    hozAlign: "center",
    visible: false,
  },
  {
    title: " ",
    field: "READ_GBN",
    widthGrow: 0.9,
    hozAlign: "center",
    width: 50,
    headerSort: false,
    formatter: (cell) => {
      const rowData = cell.getData();
      // console.log("rowData", rowData.READ_GBN);

      let img;
      if (rowData.READ_GBN === "Y") {
        img = IconEmail_Y;
      } else {
        img = IconEmail_N;
      }

      return `<img src="${img}" style="width:18px; height:18px; border-radius:50%; display:block; margin:auto;">`;
    },
  },
  {
    title: "내용",
    field: "TITLE",
    widthGrow: 3.5,
    cssClass: "cursor-pointer", // 손모양 적용
    cellClick: (e, cell) => {
      showDialog.value = false;

      nextTick(async () => {
        const rowData = cell.getData(); // ✅ 이게 전체 row 데이터
        // console.log("클릭한 row 전체 데이터:", rowData);
        //popupData.value = rowData;

        const searchParams = {
          
          ID: "WERP\\T_ALARM\\R002",
          Parameter: {
            "@R_OR_S": "R",
            "@ANO": rowData.ANO,
            "@SEQ": rowData.SEQ,
          },
        };

        const res = await apiExecuteDataSet(searchParams);
        //console.log("res", res._Result[0]);
        popupData.value = res._Result[0];

        showDialog.value = true;
        // console.log("popupData.value:", popupData.value);
        // e.stopPropagation();
      });
    },
  },
  { title: "보낸이", field: "FR_USERNAME", widthGrow: 1, hozAlign: "center" },
  { title: "보낸일자", field: "FR_DATE", widthGrow: 1, hozAlign: "center" },
  { title: "보낸시각", field: "FR_TIME", widthGrow: 1, hozAlign: "center" },
];

function handleSelection(data) {
  selectedRows.value = data;
  // console.log("선택된 행:", data);
}

function btnDeleteClick() {
  console.log("선택 삭제 행:", selectedRows.value);
}

function btnReadClick() {
  console.log("전체읽음처리 행:", selectedRows.value);
}

const popupData = ref([]);
const showDialog = ref(false);

function popupEmitClose() {
  //console.log("popupEmitClose");

  search();
}
</script>
